import Vue from 'vue';

import App from './App.vue';
// Vue Router
import router from '@/router';
// Vuex Store
import store from '@/store';
// Global Constants
import constants from '@/constants';

import $context from "./app-context";
import $cache from "./cache";

import '@/components/common-ui';


// ========================================
//
// Setup Add
//
// ========================================
// axios Add
import axios from "./setup/axios-setup";
// Multi Language Add
import { i18n } from './setup/i18n-setup';
// Apollo Add
import { apolloProvider } from './setup/apollo-setup';
// Form Validation Add
import '@/setup/vee-validate-setup';
// Global Components Add
import '@/setup/global-components-setup';
// Theme Add
import '@/setup/theme-setup';
// Filter Add
import './setup/filter-setup';
// import store_ from './store/store'
import { setDebugStatus } from '@/utils/debugger';
// Plugin Add
import '@/setup/plugin-setup'

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$constants = constants;
Vue.prototype.$env = process.env;
Vue.prototype.$developing = process.env.NODE_ENV === "development";
Vue.prototype.$debug = setDebugStatus();
Vue.prototype.$features = $context.$features;

Vue.prototype.$context = $context;
Vue.prototype.$currentUser = { active: false };
Vue.prototype.$flatmap = $cache.$flatmap;
Vue.prototype.$cache = $cache;
Vue.prototype.$eventbus = $context.eventbus;

// Theme Configurations
// import '../themeConfig.js'

// import Vuex from 'vuex'

const vm = new Vue({
  i18n,
  apolloProvider,
  router,
  store,
  // features: $context.features,
  render: h => h(App)
}).$mount('#app');

// Shared instances of tools to global object.
// window.subscription = $context.subscription;
window.eventbus = $context.eventbus;

export default vm;

/*
  For help debugging on development or local environment, don't remove
*/
if (process.env.VUE_APP_DEPLOYMENT_STAGE === "development"
  || process.env.VUE_APP_LOCAL_SERVER === "true") {

    // console.log("DEBUG: Environment Variables", process.env) // eslint-disable-line no-console

    // Added Vue instance to Global object for development only
    window.$vm = vm;
}
